import { Navigate, useLocation, useNavigate, useNavigationType } from 'react-router-dom';
import { ReactNode, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { clearStore } from '../redux/voucherActions';

interface GuardProps {
  children: ReactNode;
}

export function RequireVoucher({ children }: GuardProps): JSX.Element {
  const { voucher } = useAppSelector((s: any) => s.voucher);
  const location = useLocation();
  if (!voucher) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}

export function RequireUserDetails({ children }: GuardProps): JSX.Element {
  const { activationUserDetails } = useAppSelector((s: any) => s.voucher);
  const location = useLocation();
  if (!activationUserDetails) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}

// Redirect to success when user details exist (used on create-voucher route)
export function RedirectToSuccessOnUserDetails({ children }: GuardProps): JSX.Element {
  const { activationUserDetails } = useAppSelector((s: any) => s.voucher);
  const navigate = useNavigate();
  useEffect(() => {
    if (activationUserDetails) {
      navigate('/success', { replace: true });
    }
  }, [activationUserDetails, navigate]);
  return <>{children}</>;
}

// Handle browser back/forward: on POP, clear tokens and go home
export function PopToHomeWithTokenClear({ children }: GuardProps): JSX.Element {
  const navType = useNavigationType();
  const location = useLocation();
  const navigate = useNavigate();
  const handledKeyRef = useRef<string | null>(null);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (navType !== 'POP') return;
    if (handledKeyRef.current === location.key) return;
    handledKeyRef.current = location.key;

    dispatch(clearStore());
    navigate('/', { replace: true });
  }, [location.key, navType, navigate, dispatch]);

  return <>{children}</>;
}

